<template>
  <section id="popReceipe">
    <div v-if="lang === 'en'" class="wrapper bg-white rounded">
      <div class="p-1">
        <img src="../assets/logo/easyRemessa-logo.png" alt="EasyRemessa logo" class="img-fluid easy-logo">

        <div class="text-center mt-3">
          <h2 class="title">{{ reference_of_transaction }}</h2>
          <h2 class="title">{{ amount }}</h2>
          <p>{{ formatDate(date) }}</p>
        </div>

        <hr class="my-4 hr"/>

        <b-row>
          <b-col cols="4" class="text-left">
            <h2 class="title font-weight-semibold mb-5 text-dark">
              Proof of <br/>
              Payment
            </h2>
<!--            <div class="mb-5" style="line-height: 1.5">-->
<!--              <p class="">{{ formatDate(date) }}</p>-->
<!--              <p class="">{{ reference_of_transaction }}</p>-->
<!--              <p class="">{{ contact_email }}</p>-->
<!--            </div>-->

            <div class="contact-address">
              <p class="title font-weight-normal text-md text-dark">easyremessa by yvoefrance</p>
              <p>{{ contact_address.street }}</p>
              <p>{{ contact_address.postal_code }}</p>
              <p>{{ contact_address.country }}</p>
              <p>{{ contact_address.other }}</p>
              <p>{{ contact_email }}</p>
            </div>
          </b-col>

          <b-col cols="8">
            <div class="data">
              <h4 class="">{{ data_of_remittent.title }}</h4>
              <div class="table-wrapper">
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>{{ data_of_remittent.name }}</td>
                  </tr>
                  <tr>
                    <th>CPF/ CNPJ:</th>
                    <td>{{ format_cpf(data_of_remittent.cpf_cnpj) }}</td>
                  </tr>
                </table>
              </div>
            </div>

<!--            <div class="data">-->
<!--              <h4 class="">{{ bank_of_beneficiary.title }}</h4>-->

<!--              <div class="table-wrapper">-->
<!--                <table>-->
<!--                  <tr>-->
<!--                    <th>Name:</th>-->
<!--                    <td>{{ bank_of_beneficiary.name }}</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>CPF/ CNPJ:</th>-->
<!--                    <td>{{ format_cpf(bank_of_beneficiary.cnpj) }}</td>-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </div>-->
<!--            </div>-->

            <div class="data">
              <h4 class="">{{ name_of_beneficiary.title }}</h4>

              <div class="table-wrapper">
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>{{ name_of_beneficiary.name }}</td>
                  </tr>
                  <tr>
                    <th>CPF/ CNPJ:</th>
                    <td>{{ format_cpf(name_of_beneficiary.cpf_cnpj) }}</td>
                  </tr>
                  <tr>
                    <th>Beneficiary Bank:</th>
                    <td>{{ bank_of_beneficiary.name }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="data">
              <h4 class="">{{ data_of_final_payer.title }}</h4>

              <div class="table-wrapper">
                <table>
                  <tr v-for="item in data_of_final_payer.data" :key="item.id">
                    <th>{{ item.key }}</th>
                    <td v-if="item.key === 'CNPJ'">{{ format_cpf(item.value) }}</td>
                    <td v-else>{{ item.value }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="data">
              <h4 class="">{{ data_of_payment.title }}</h4>

              <div class="table-wrapper">
                <table>
                  <tr v-for="item in data_of_payment.data" :key="item.id">
                    <th>{{ item.key }}</th>
                    <td v-if="item.key === 'Due Date'">{{ formatDate(item.value) }}</td>
                    <td v-else-if="item.key === 'Date of Transaction'">{{ formatDate(item.value) }}</td>
                    <td v-else-if="item.key === 'Exchange Rate'">{{ formatFx(item.value) }}</td>
                    <td v-else>{{ item.value }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="lang === 'br' || lang === 'pt' " class="wrapper bg-white rounded position-relative">
      <div class="p-1">
        <img src="../assets/logo/easyRemessa-logo.png" alt="EasyRemessa logo" class="img-fluid easy-logo">

        <div class="text-center mt-3">
          <h2 class="title">{{ reference_of_transaction }}</h2>
          <h2 class="title">{{ amount }}</h2>
          <p>{{ formatDate(date) }}</p>
        </div>

        <hr class="my-4 hr"/>

        <b-row>
          <b-col cols="4">
            <h2 class="title font-weight-semibold mb-5 text-dark">
              COMPROVANTE <br/>
              DE PAGAMENTO
            </h2>

<!--            <div class="mb-5" style="line-height: 1.5">-->
<!--              <p class="">{{ formatDate(date) }}</p>-->
<!--              <p class="">{{ reference_of_transaction }}</p>-->
<!--              <p class="">{{ contact_email }}</p>-->
<!--            </div>-->

            <div class="contact-address mb-5">
              <p class="title font-weight-normal text-md text-dark">
                easyremessa por <br/>
                yvoefrance
              </p>
              <p>{{ contact_address.street }}</p>
              <p>{{ contact_address.postal_code }}</p>
              <p>{{ contact_address.country }}</p>
              <p>{{ contact_address.other }}</p>
              <p>{{ contact_email }}</p>
            </div>
          </b-col>

          <b-col cols="8">
            <div class="data">
              <h4 class="">DADOS DO REMITENTE</h4>
              <div class="table-wrapper">
                <table>
                  <tr>
                    <th>Nome:</th>
                    <td>{{ data_of_remittent.name }}</td>
                  </tr>
                  <tr>
                    <th>CPF/ CNPJ:</th>
                    <td>{{ format_cpf(data_of_remittent.cpf_cnpj) }}</td>
                  </tr>
                </table>
              </div>
            </div>

<!--            <div class="data">-->
<!--              <h4 class="">BANCO DO BENEFICIÁRIO</h4>-->

<!--              <div class="table-wrapper">-->
<!--                <table>-->
<!--                  <tr>-->
<!--                    <th>Nome:</th>-->
<!--                    <td>{{ bank_of_beneficiary.name }}</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>CPF/ CNPJ:</th>-->
<!--                    <td>{{ format_cpf(bank_of_beneficiary.cnpj) }}</td>-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </div>-->
<!--            </div>-->

            <div class="data">
              <h4 class="">DADOS DO BENEFICIÁRIO</h4>

              <div class="table-wrapper">
                <table>
                  <tr>
                    <th>Nome:</th>
                    <td>{{ name_of_beneficiary.name }}</td>
                  </tr>
                  <tr>
                    <th>CPF/ CNPJ:</th>
                    <td>{{ format_cpf(name_of_beneficiary.cpf_cnpj) }}</td>
                  </tr>
                  <tr>
                    <th>Banco do beneficiário:</th>
                    <td>{{ bank_of_beneficiary.name }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="data">
              <h4 class="">DADOS DO PAGADOR FINAL</h4>

              <div class="table-wrapper">
                <table>
                  <tr>
                    <th>Nome:</th>
                    <td>{{ data_of_final_payer.data[0].value }}</td>
                  </tr>
                  <tr>
                    <th>CNPJ:</th>
                    <td>{{ data_of_final_payer.data[1].value }}</td>
                  </tr>
                  <tr>
                    <th>Conta:</th>
                    <td>{{ data_of_final_payer.data[2].value }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="data">
              <h4 class="">DADOS DO PAGAMENTO</h4>

              <table>
                <tr>
                  <th>Banco Emissor:</th>
                  <td>{{ data_of_payment.data[0].value }}</td>
                </tr>
                <tr>
                  <th>Data de Vencimento:</th>
                  <td>{{ formatDueDate(data_of_payment.data[1].value) }}</td>
                </tr>
                <tr>
                  <th>Valor R$:</th>
                  <td>{{ data_of_payment.data[2].value }}</td>
                </tr>
                <tr>
                  <th>Valor enviado:</th>
                  <td>{{ data_of_payment.data[3].value }}</td>
                </tr>
                <tr>
                  <th>Custo da Transação:</th>
                  <td>{{ data_of_payment.data[4].value }}</td>
                </tr>
                <tr>
                  <th>Câmbio da Transação:</th>
                  <td>{{ formatFx(data_of_payment.data[5].value) }}</td>
                </tr>
                <tr>
                  <th>Canal de solicitação:</th>
                  <td>{{ data_of_payment.data[6].value }}</td>
                </tr>
                <tr>
                  <th>Data da Transação:</th>
                  <td>{{ formatDate(data_of_payment.data[7].value) }}</td>
                </tr>
                <tr>
                  <th>Documento n°:</th>
                  <!-- <td style="word-break: break-word;">{{ data_of_payment.data[8].value }}</td> -->
                  <td>{{ data_of_payment.data[8].value }}</td>
                </tr>
<!--                <tr>-->
<!--                  <th>Referência:</th>-->
<!--                  <td>{{ data_of_payment.data[9].value }}</td>-->
<!--                </tr>-->
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PopReceipe",
  props: ["pdfFileData", "lang"],
  data() {
    return {
      ...this.pdfFileData,
    };
  },
  methods: {
    formatDate: function (value) {
      if (value) {
        value = this.$dayjs(value).utc().format("DD/MM/YYYY - HH:mm z");
      }
      return value
    },
    formatDueDate: function (value) {
      if (value) {
        // Thu Jan 06 2022 10:15:03 GMT+0100
        value = this.$dayjs(value).utc().format("DD/MM/YYYY");
      }
      return value
    },
    formatFx: function (value) {
      value = Number(value)
      if (value) {
        value = value.toFixed(4)
      }
      return value
    },
    format_cpf: function (value) {
      if (value) {
        if (value.length === 14) {
          return value.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
        } else {
          return value.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
$primary-color: #212427;

.wrapper {
  font-family: Montserrat, sans-serif !important;
  padding: 1rem 2.5rem;
  width: 21cm;
  height: 29.5cm;
  margin: 0 auto;
  font-size: 10px;
}


.easy-logo {
  height: 2.5rem;
  margin-right: auto;
  margin-left: 0;
}

/* Utility Classes */
.title {
  font-size: 1.45em;
  font-weight: bold;
  line-height: 1.5;
  color: $primary-color;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.font-weight-semibold {
  font-weight: 500;
}

.text-md {
  font-size: 1.25em;
}

.hr {
  border-top: 2px solid $primary-color;
  opacity: 0.4;
}

.contact-address {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  line-height: 0.8;
}

.data {
  margin-bottom: 2.5rem;

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: "Open Sans", sans-serif;
    font-size: 1rem;
    color: #444;

    tr {
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }
    }

    th,
    td {
      text-align: left;
      font-family: Montserrat, sans-serif;
      padding: 0.5rem 0.75rem;
      white-space: normal;
      width: 35%;
      font-size: 10px;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    th {
      font-weight: 500;
    }

    td {
      flex: 0 0 10rem;
      width: 10rem;
      min-width: 10rem;
      word-break: break-all;
    }
  }

  h4 {
    font-size: 1.25em;
    letter-spacing: 0px;
    color: $primary-color;
    text-transform: uppercase;
    text-align: left;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
